import { Bell, Building2, ChevronDown, Menu, Moon, Sun } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Topbar({ crumb, onOpenMenu, dark, toggleDark }) {
  const { user } = useAuth();
  const initials = (user?.name || user?.email || "V")
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <header className="topbar" data-testid="topbar">
      <button className="mobile-menu icon-btn" onClick={onOpenMenu} data-testid="open-mobile-menu">
        <Menu size={20} />
      </button>
      <div className="crumb">
        <span>Çalışma alanı</span>
        <b>/</b>
        <strong>{crumb}</strong>
      </div>
      <div className="top-actions">
        <button className="company-top" data-testid="top-company">
          <Building2 size={16} />
          <span>{user?.company_name || "—"}</span>
          <ChevronDown size={14} />
        </button>
        <button className="icon-btn" onClick={toggleDark} data-testid="theme-toggle" aria-label="Tema">
          {dark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <button className="icon-btn notification" data-testid="notifications-button" aria-label="Bildirimler">
          <Bell size={18} />
          <i />
        </button>
        <div className="top-avatar" data-testid="top-avatar">
          {initials}
        </div>
      </div>
    </header>
  );
}
